import { Component, Input } from "@angular/core";
import { SampleBoardItem, SampleBoardItemStatus } from "@app/strain/sample-boards/models/sample-board-item.model";

@Component({
    selector: 'app-sample-board-stoc-list-item',
    templateUrl: './sample-board-stoc-list-item.component.html',
    styleUrls: ['./sample-board-stoc-list-item.component.scss']
})
export class SampleBoardStocListItemComponent {
    @Input() item: SampleBoardItem;

    get statusLabel(): string {
        const status = this.item?.status ?? SampleBoardItemStatus.ValidationPending;
        switch (status) {
            case SampleBoardItemStatus.AvailableInStock:
                return 'admin.strain.sample-boards.details.tabs.stoc.status.available';
            case SampleBoardItemStatus.ValidationPending:
                return 'admin.strain.sample-boards.details.tabs.stoc.status.validationPending';
            case SampleBoardItemStatus.ValidationInProgress:
                return 'admin.strain.sample-boards.details.tabs.stoc.status.validationInProgress';
            case SampleBoardItemStatus.Destroyed:
                return 'admin.strain.sample-boards.details.tabs.stoc.status.destroyed';
            default:
                return 'admin.strain.sample-boards.details.tabs.stoc.status.unknown';
        }
    }

    get statusClass(): string {
        switch (this.item?.status) {
            case SampleBoardItemStatus.AvailableInStock:
                return 'status--ok';
            case SampleBoardItemStatus.ValidationPending:
                return 'status--pending';
            case SampleBoardItemStatus.ValidationInProgress:
                return 'status--progress';
            case SampleBoardItemStatus.Destroyed:
                return 'status--danger';
            default:
                return 'status--unknown';
        }
    }
}
